import Flickity from 'flickity';

export default class DynamicSlideshow {
  constructor(section) {
    this.el = section.el;
    this.$el = $(this.el);
    this.slideshow = this.el.querySelector('[data-slideshow]');
    this.flickity = null;
    this.slideCount = this.slideshow.querySelectorAll('[data-slideshow-slide]').length;
    this.autoplay = section.data.autoplay ? section.data.autoplay : null;

    this.autoplayHoverPause = this.autoplay ? section.data.autoplayHoverPause : false;
    this.autoplayDelay = this.autoplay ? section.data.autoplayDelay * 1000 : null;
    this._resizeFlickity = this._resizeFlickity.bind(this);
    this._setupSlideshow();
  }

  onSectionUnload() {
    if (this.flickity) {
      this.slideshow.removeEventListener('rimg:load', this._resizeFlickity);
      this.flickity.destroy();
      this.flickity = null;
    }
  }

  onSectionBlockSelect(block) {
    if (!this.flickity) { return; }
    const slideIndex = parseInt($(block.el).data('slide-index'), 10);
    this.flickity.select(slideIndex, true);
    if (this.autoplay) {
      this.flickity.stopPlayer();
    }
  }

  onSectionBlockDeselect(block) {
    if (this.autoplay) {
      this.flickity.playPlayer();
    }
  }

  _setupSlideshow() {
    if (this.slideCount > 1) {
      this.flickity = new Flickity(this.slideshow, {
        adaptiveHeight: true,
        autoPlay: this.autoplayDelay,
        cellSelector: '[data-slideshow-slide]',
        pageDots: true,
        pauseAutoPlayOnHover: this.autoplayHoverPause,
        prevNextButtons: true,
        resize: true,
        wrapAround: true,
        draggable: true,
      });
      this.slideshow.addEventListener('rimg:load', this._resizeFlickity);
    }
  }

  _resizeFlickity() {
    if (this.flickity) {
      this.flickity.resize();
    }
  }
}
